<div>
  <mat-toolbar>
    <span>
      <img class="logo" src="../../../assets/bwh-hotel-group.png" />
    </span>
  </mat-toolbar>
  <div class="spacer"></div>
</div>
